<template id="Cni_passeport">
	<div>
		<Modele id="Cni"/>
		<Modele id="Passeport"/>
		<Modele id="Cni_passeport"/>
	</div>
</template>

<script>
import Modele from '../Modele.vue'
export default {
	components:{Modele},
	name: 'Cni_passeport',
	data () {
		return {}
	}
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/EtatCivil/Cni_passeport.vue